// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2rAaA","dragIcon":"SortableItem_dragIcon__1Op0V","disabled":"SortableItem_disabled__2vthE"};